import type { EnvironmentThreadStatus } from "@afar-research/client-runtime/state/threads";

export type ThreadSyncPhase = "loading" | "syncing";

export function resolveThreadSyncPhase(input: {
  readonly detailExists: boolean;
  readonly shellExists: boolean;
  readonly status: EnvironmentThreadStatus;
}): ThreadSyncPhase | null {
  if (!input.shellExists) {
    return null;
  }

  switch (input.status) {
    case "starting":
    case "synchronizing":
      // Already holding messages means this is a catch-up, not a first load.
      return input.detailExists ? "syncing" : "loading";
    case "unavailable":
    case "deleted":
    case "ready":
      return null;
  }
}

export function threadSyncLabel(phase: ThreadSyncPhase): string {
  return phase === "loading" ? "Loading messages..." : "Syncing messages...";
}
